import { render } from "./CheckYourEmail.vue?vue&type=template&id=4496c95e&scoped=true"
import script from "./CheckYourEmail.vue?vue&type=script&lang=js"
export * from "./CheckYourEmail.vue?vue&type=script&lang=js"

import "./CheckYourEmail.vue?vue&type=style&index=0&id=4496c95e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4496c95e"],['__file',"CheckYourEmail.vue"]])

export default __exports__